import { Injectable } from '@angular/core';

import {
  ConfigService,
  EntityService
} from 'viggo-sistemas-core-web';

import { IFornecedor } from '../models/fornecedor.model';

@Injectable()
export class FornecedorService extends EntityService<IFornecedor> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'fornecedor',
        pluralBaseEntityEndPoint: 'fornecedores'
      }
    );
  }
}
